import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

/**
 * *Is this your business?* (DOC-93 §1). The name CIPC holds and one question; it
 * shows nothing else CIPC returned, and neither answer is pre-selected.
 */
@Component({
  selector: 'app-company-name-check',
  imports: [MatButtonModule],
  template: `
    <div class="name-check" data-testid="company-name-check">
      <p class="name-check__question">
        CIPC has this number registered to <strong>{{ name() }}</strong
        >. Is this your business?
      </p>
      <div class="name-check__actions">
        <button
          mat-stroked-button
          type="button"
          (click)="answered.emit('YES')"
          data-testid="company-name-yes"
        >
          Yes, that's us
        </button>
        <button
          mat-button
          type="button"
          (click)="answered.emit('NO')"
          data-testid="company-name-no"
        >
          No — let me check the number
        </button>
      </div>
    </div>
  `,
  styles: `
    .name-check {
      margin: var(--space-2) 0;
      padding: var(--space-3) var(--space-4);
      border: 1px solid var(--border);
      border-radius: var(--radius-lg);
    }
    .name-check__question {
      margin: 0 0 var(--space-2);
    }
    .name-check__actions {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-2);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyNameCheckComponent {
  readonly name = input.required<string>();
  readonly answered = output<'YES' | 'NO'>();
}
